import React from 'react';

import { Box, Fade, Paper, Typography } from '@material-ui/core';

import { AppSwitch, OnboardingStepTitle } from '@vyce/core/src/components';
import { Team, TimeAndAttendanceLocation } from '@vyce/core/src/types';

import { FormTeamsStep } from './FormTeamsStep';
import { FormLocationsStep } from './FormLocationsStep';
import { RecipientScope } from './FormRecipientsModeStep';

interface Props {
  teams: Team[];
  locations: TimeAndAttendanceLocation[];
  selectedTeams: Team[];
  setSelectedTeams: (teams: Team[]) => void;
  selectedLocations: TimeAndAttendanceLocation[];
  setSelectedLocations: (locations: TimeAndAttendanceLocation[]) => void;
  recipientScope: RecipientScope;
  setRecipientScope: (scope: RecipientScope) => void;
}

export const FormLinkedTeamsLocations: React.FC<Props> = ({
  teams,
  locations,
  selectedTeams,
  setSelectedTeams,
  selectedLocations,
  setSelectedLocations,
  recipientScope,
  setRecipientScope,
}) => {
  const showLocations = recipientScope === 'location';

  return (
    <Fade in={true} timeout={200}>
      <div>
        <Paper variant="outlined" style={{ padding: 24 }}>
          <OnboardingStepTitle
            text="Linked teams & locations"
            additionalText="Everyone on a selected team or location is automatically assigned this form — now and as new members join."
          />

          <Box marginTop={2} maxWidth={360}>
            <AppSwitch
              checked={showLocations}
              onChange={checked => setRecipientScope(checked ? 'location' : 'team')}
              leftOption={{
                content: (
                  <Typography style={{ fontSize: 14, fontWeight: 600 }}>
                    Teams · {selectedTeams.length}
                  </Typography>
                ),
              }}
              rightOption={{
                content: (
                  <Typography style={{ fontSize: 14, fontWeight: 600 }}>
                    Locations · {selectedLocations.length}
                  </Typography>
                ),
              }}
            />
          </Box>

          <Box marginTop={3} maxHeight={360} style={{ overflowY: 'auto' }}>
            {showLocations ? (
              <FormLocationsStep
                embedded
                locations={locations}
                selectedLocations={selectedLocations}
                setSelectedLocations={setSelectedLocations}
              />
            ) : (
              <FormTeamsStep
                embedded
                teams={teams}
                selectedTeams={selectedTeams}
                setSelectedTeams={setSelectedTeams}
              />
            )}
          </Box>
        </Paper>
      </div>
    </Fade>
  );
};
